import type {
  DiscoverVerifyResponse,
  DiscoverVerifyResponseMembershipsInner,
  TokenRequest,
  TokenRequestEmailTx,
  TokenRequestLoginTx,
  TokenRequestOidcTx,
  TokenRequestSamlTx,
  TokenRequestRefresh
} from '@app/types/sdk';
import type { PublicKeyCredentialCreationOptionsJSON, PublicKeyCredentialRequestOptionsJSON } from '@app/utils/webauthn';

export type DiscoveryResponse = DiscoverVerifyResponse;
export type DiscoveryMembership = DiscoverVerifyResponseMembershipsInner;

export interface PasskeyAssertionOptionsResponse {
  publicKey: PublicKeyCredentialRequestOptionsJSON;
  challengeToken: string;
  challengeTokenExpiresAt?: string | Date | null;
}

export interface PasskeyAssertionVerifyResponse {
  loginTx: string;
  loginTxExpiresAt?: string | Date | null;
}

export interface PasskeyAttestationOptionsResponse {
  publicKey: PublicKeyCredentialCreationOptionsJSON;
  challengeToken: string;
  challengeTokenExpiresAt?: string | Date | null;
}

export interface PasskeyAttestationVerifyResponse {
  credentialId?: string;
  registeredAt?: string | Date | null;
  nextStep?: 'authenticatePasskey' | 'exchangeLoginTx';
  loginTx?: string | null;
  loginTxExpiresAt?: string | Date | null;
}

export interface PasswordVerifyResponse {
  loginTx: string;
  loginTxExpiresAt?: string | Date | null;
  nextStep?: 'success' | 'requirePasswordSetup' | 'requirePasswordReset';
}

export interface PasswordRegisterResponse {
  registeredAt?: string | Date | null;
  loginTx?: string | null;
  loginTxExpiresAt?: string | Date | null;
  nextStep?: 'exchangeLoginTx' | 'authenticatePassword';
}

export type TokenGrantRequest =
  | (TokenRequestLoginTx & { orgId?: string })
  | (TokenRequestOidcTx & { orgId?: string })
  | (TokenRequestSamlTx & { orgId?: string })
  | (TokenRequestEmailTx & { orgId?: string })
  | (TokenRequestRefresh & { orgId?: string });

export const toTokenRequest = (request: TokenGrantRequest): TokenRequest => request as TokenRequest;
